// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planpage {
  padding: 30px 50px;
}

.checkout-custom-select {
  display: flex;
  flex-direction: column;
}
.checkout-custom-select span {
  font-weight: 700;
}
.checkout-custom-select select {
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  margin-top: 4px;
  cursor: pointer;
  appearance: none;
}
.checkout-custom-select select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);
}

.checkoutCustomInput {
  display: flex;
  flex-direction: column;
}
.checkoutCustomInput span {
  font-weight: 700;
}
.checkoutCustomInput input {
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  margin-top: 4px;
  font-size: 16px;
}
.checkoutCustomInput input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);
}

.subscription-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 20px;
}
@media (min-width: 640px) {
  .subscription-container {
    grid-template-columns: 1fr 1fr;
  }
}
.subscription-container .subscription-box {
  width: 100%;
  height: 100vh;
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  padding: 20px;
  overflow: auto;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.subscription-container .subscription-box .zoho-checkout-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.subscription-container .subscription-box .zoho-checkout-header h3 {
  font-weight: 700;
  font-size: 24px;
}
.subscription-container .subscription-box .plan-section,
.subscription-container .subscription-box .billing-section,
.subscription-container .subscription-box .details-section {
  margin-top: 20px;
}
.subscription-container .subscription-box .plan-section .zoho-checkout-address-section,
.subscription-container .subscription-box .billing-section .zoho-checkout-address-section,
.subscription-container .subscription-box .details-section .zoho-checkout-address-section {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 0.5rem;
  gap: 1.25rem;
}
.subscription-container .subscription-box .plan-section h4,
.subscription-container .subscription-box .billing-section h4,
.subscription-container .subscription-box .details-section h4 {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
}
.subscription-container .subscription-box .plan-section .plan-info .left-side h4,
.subscription-container .subscription-box .billing-section .plan-info .left-side h4,
.subscription-container .subscription-box .details-section .plan-info .left-side h4 {
  font-size: 16px;
}
.subscription-container .subscription-box .plan-section .plan-info .left-side h4 span,
.subscription-container .subscription-box .billing-section .plan-info .left-side h4 span,
.subscription-container .subscription-box .details-section .plan-info .left-side h4 span {
  color: #3b82f6;
}
.subscription-container .subscription-box .plan-section .plan-info .left-side .licence-type,
.subscription-container .subscription-box .billing-section .plan-info .left-side .licence-type,
.subscription-container .subscription-box .details-section .plan-info .left-side .licence-type {
  font-size: 16px;
  color: black;
  margin-top: 10px;
}
.subscription-container .subscription-box .plan-section .plan-info,
.subscription-container .subscription-box .billing-section .plan-info,
.subscription-container .subscription-box .details-section .plan-info {
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.subscription-container .subscription-box .plan-section .plan-info .license-input,
.subscription-container .subscription-box .billing-section .plan-info .license-input,
.subscription-container .subscription-box .details-section .plan-info .license-input {
  border: 1px solid #d4d4d8;
  border-radius: 10px;
  padding: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  justify-content: space-between;
}
.subscription-container .subscription-box .plan-section .plan-info .license-input button,
.subscription-container .subscription-box .billing-section .plan-info .license-input button,
.subscription-container .subscription-box .details-section .plan-info .license-input button {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
}
.subscription-container .subscription-box .plan-section .billing-options,
.subscription-container .subscription-box .billing-section .billing-options,
.subscription-container .subscription-box .details-section .billing-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.subscription-container .subscription-box .plan-section .billing-options button,
.subscription-container .subscription-box .billing-section .billing-options button,
.subscription-container .subscription-box .details-section .billing-options button {
  width: 100%;
  padding: 20px;
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  border-radius: 10px;
  cursor: pointer;
}
.subscription-container .subscription-box .plan-section .billing-options .selected,
.subscription-container .subscription-box .billing-section .billing-options .selected,
.subscription-container .subscription-box .details-section .billing-options .selected {
  border: 4px solid #3b82f6;
}
.subscription-container .subscription-box .plan-section .billing-options .not-selected,
.subscription-container .subscription-box .billing-section .billing-options .not-selected,
.subscription-container .subscription-box .details-section .billing-options .not-selected {
  border: 1px solid #d4d4d8;
}
.subscription-container .subscription-box .plan-section .input-field,
.subscription-container .subscription-box .billing-section .input-field,
.subscription-container .subscription-box .details-section .input-field {
  width: 100%;
  border: 1px solid #d4d4d8 !important;
  border-radius: 10px;
  padding: 10px;
}
.subscription-container .subscription-box .plan-section .plan-page-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
.subscription-container .subscription-box .plan-section h4 {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0px;
}
.subscription-container .subscription-box .coupon-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  gap: 20px;
}
.subscription-container .subscription-box .coupon-section .custom-discount-apply-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.subscription-container .subscription-box .coupon-section button {
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.subscription-container .subscription-box .coupon-section button.custom-discount-clear-btn {
  background-color: red;
  color: white;
}
.subscription-container .subscription-box .coupon-section button.custom-discount-apply-btn {
  background-color: #3b82f6;
  color: white;
}
.subscription-container .subscription-box .pricing-summary {
  margin-top: 20px;
  border-top: 1px solid #d4d4d8;
  padding-top: 20px;
}
.subscription-container .subscription-box .pricing-summary .summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.subscription-container .subscription-box .pricing-summary .summary-item h4 {
  font-weight: 700;
  font-size: 20px;
}
.subscription-container .subscription-box .pricing-summary .summary-item h4.discount {
  color: #6b7280;
}
.subscription-container .subscription-box .purchase-button {
  width: 100%;
  margin-top: 20px;
  background-color: #3b82f6;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  cursor: pointer;
}
.subscription-container .subscription-image {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plan-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.plan-container .plan-type-group {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
}
.plan-container .plan-type-group .plan-type-btn {
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 2px solid transparent;
  color: #bdbdbd;
  transition: all 0.3s ease-in-out;
  background-color: transparent;
  cursor: pointer;
}
.plan-container .plan-type-group .plan-type-btn.active {
  background-color: transparent;
  color: black;
  border-color: #3b82f6;
}
.plan-container .plan-tenure-toggle {
  border: 1px solid #404040;
  display: flex;
  align-items: center;
  height: 40px;
  width: max-content;
  padding: 6px;
  border-radius: 10px;
  gap: 10px;
}
.plan-container .plan-tenure-toggle .tenure-btn {
  height: 100%;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease-in-out;
  background: transparent;
  color: #616161;
  cursor: pointer;
}
.plan-container .plan-tenure-toggle .tenure-btn.active {
  background: black;
  color: white;
}

.plan-section-tabs-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: -1px;
}
.plan-section-tabs-container .plan-section-tabs-group-list {
  width: 100%;
  display: flex;
  align-items: center;
}
.plan-section-tabs-container .plan-section-tabs-group-list .plan-type-btn {
  font-size: 16px;
  font-weight: 600;
  border-bottom: 0px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  padding: 7.5px 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: transparent;
}
.plan-section-tabs-container .plan-section-tabs-group-list .plan-type-btn.active {
  color: #3B82F6;
  border-color: #D4D4D8;
  background-color: #fff;
}

.plan-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  background-color: #fff;
  border: 1px solid #D4D4D8;
  border-radius: 0px 10px 10px 10px;
}
@media (min-width: 640px) {
  .plan-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
.plan-grid .plan-card {
  border-bottom: 1px solid #aaaaaa;
  padding: 20px;
  padding-left: 0;
}
.plan-grid .plan-card:nth-child(4n+1) {
  padding-left: 20px;
}
.plan-grid .plan-card:nth-child(4n) {
  padding-left: 0;
}
.plan-grid .plan-card {
  cursor: pointer;
}
.plan-grid .plan-card .plan-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 15px;
  color: #616161;
}
.plan-grid .plan-card .plan-image {
  width: 100%;
  object-fit: cover;
  transition: transform 0.2s ease-in-out;
}
.plan-grid .plan-card .plan-image:hover {
  transform: scale(1.02);
}

.cancel-subscription-warn-container {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
}
.cancel-subscription-warn-container .cancel-subscription-warn-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cancel-subscription-warn-container .cancel-subscription-warn-header h2 {
  font-size: 20px;
  font-weight: 700;
}
.cancel-subscription-warn-container .cancel-subscription-warn-header button {
  background: none;
  border: none;
  cursor: pointer;
}
.cancel-subscription-warn-container .cancel-subscription-warn-description {
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  width: 100%;
  color: #6b7280;
}
.cancel-subscription-warn-container .cancel-subscription-warn-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.cancel-subscription-warn-container .cancel-subscription-warn-actions .primaryButton {
  background-color: #3b82f6;
  color: white;
  border-radius: 6px;
  width: auto;
  padding: 10px 20px;
  border: 0;
  cursor: pointer;
}
.cancel-subscription-warn-container .cancel-subscription-warn-actions .primaryButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.zoho-custom-checkbox {
  all: unset;
  appearance: auto;
  display: inline-block;
  width: auto;
  height: auto;
}

.checkbox-label-zoho-cancel-current {
  padding-left: 10px;
}

.zoho-coupon-container {
  padding-top: 20px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
  padding: 20px;
  width: 100%;
}
.zoho-coupon-container .zoho-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.zoho-coupon-container .zoho-header h2 {
  font-size: 20px;
  font-weight: 700;
}
.zoho-coupon-container .sub-header {
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
  text-align: center;
  width: 100%;
}
.zoho-coupon-container .coupon-card {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  height: auto;
}
.zoho-coupon-container .coupon-card .coupon-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  width: 100%;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details h4 {
  font-size: 20px;
  font-weight: 700;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details h5 {
  font-size: 16px;
  font-weight: 700;
  color: #6b7280;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details .coupon-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details .coupon-actions .coupon-code {
  border-radius: 6px;
  background-color: #d1d5db;
  padding: 6px 10px;
  font-weight: 600;
  width: max-content;
}
.zoho-coupon-container .coupon-card .coupon-content .coupon-details .coupon-actions .apply-button {
  font-size: 16px;
  color: #3b82f6;
  font-weight: 600;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Plan/Plan.scss"],"names":[],"mappings":"AAUA;EACI,kBAAA;AATJ;;AAYA;EACI,aAAA;EACA,sBAAA;AATJ;AAWI;EACI,gBAAA;AATR;AAYI;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAVR;AAYQ;EACI,aAAA;EACA,qBAAA;EACA,2CAAA;AAVZ;;AAeA;EACI,aAAA;EACA,sBAAA;AAZJ;AAcI;EACI,gBAAA;AAZR;AAeI;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAbR;AAeQ;EACI,aAAA;EACA,qBAAA;EACA,2CAAA;AAbZ;;AAmBA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAhBJ;AAkBI;EAPJ;IAQQ,8BAAA;EAfN;AACF;AAiBI;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,0CAAA;AAfR;AAiBQ;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;AAfZ;AAiBY;EACI,gBAAA;EACA,eAAA;AAfhB;AAmBQ;;;EAGI,gBAAA;AAjBZ;AAmBY;;;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;AAfhB;AAkBY;;;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAdhB;AAmBoB;;;EACI,eAAA;AAfxB;AAiBwB;;;EACI,cAAA;AAb5B;AAiBoB;;;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAbxB;AAAY;;;EAiBI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAZhB;AAcgB;;;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,8BAAA;AAVpB;AAYoB;;;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AARxB;AAaY;;;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAThB;AAWgB;;;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAPpB;AAUgB;;;EACI,yBAAA;AANpB;AASgB;;;EACI,yBAAA;AALpB;AASY;;;EACI,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;AALhB;AAUY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AARhB;AAWY;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AAThB;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AAXZ;AAaY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAXhB;AAcY;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAZhB;AAcgB;EACI,qBAAA;EACA,YAAA;AAZpB;AAegB;EACI,yBAAA;EACA,YAAA;AAbpB;AAkBQ;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAhBhB;AAkBgB;EACI,gBAAA;EACA,eAAA;AAhBpB;AAkBoB;EACI,cAAA;AAhBxB;AAsBQ;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AApBZ;AAwBI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtBR;;AA2BA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxBJ;AA0BI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAxBR;AA0BQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cA5SA;EA6SA,gCAAA;EACA,6BAAA;EACA,eAAA;AAxBZ;AA0BY;EACI,6BAAA;EACA,YAhTR;EAiTQ,qBArTA;AA6RhB;AA8BI;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;AA5BR;AA8BQ;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;EACA,cA1UE;EA2UF,eAAA;AA5BZ;AA8BY;EACI,iBA7UR;EA8UQ,YA7UR;AAiTR;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA/BJ;AAiCI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AA/BR;AAiCQ;EACI,eAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EAGA,6BAAA;AAnCZ;AAqCY;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;AAnChB;;AA0CA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,MAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;AAvCJ;AAyCI;EATJ;IAUQ,qCAAA;EAtCN;AACF;AAwCI;EACI,gCAAA;EACA,aAAA;EACA,eAAA;AAtCR;AAwCQ;EACI,kBAAA;AAtCZ;AAyCQ;EACI,eAAA;AAvCZ;AA6BI;EAaI,eAAA;AAvCR;AAyCQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAvZK;AAgXjB;AA0CQ;EACI,WAAA;EACA,iBAAA;EACA,sCAAA;AAxCZ;AA0CY;EACI,sBAAA;AAxChB;;AA8CA;EACI,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AA3CJ;AA6CI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA3CR;AA6CQ;EACI,eAAA;EACA,gBAAA;AA3CZ;AA8CQ;EACI,gBAAA;EACA,YAAA;EACA,eAAA;AA5CZ;AAgDI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AA9CR;AAiDI;EACI,WAAA;EACA,aAAA;EACA,yBAAA;AA/CR;AAiDQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;AA/CZ;AAiDY;EACI,YAAA;EACA,mBAAA;AA/ChB;;AAqDA;EACI,UAAA;EAEA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAlDJ;;AAqDA;EACI,kBAAA;AAlDJ;;AA+EA;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AA5EJ;AA8EI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA5ER;AA8EQ;EACI,eAAA;EACA,gBAAA;AA5EZ;AAgFI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AA9ER;AAiFI;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA/ER;AAiFQ;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AA/EZ;AAiFY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AA/EhB;AAiFgB;EACI,eAAA;EACA,gBAAA;AA/EpB;AAkFgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAhFpB;AAmFgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAjFpB;AAmFoB;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAjFxB;AAoFoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAlFxB","sourcesContent":["$primary-color: #3b82f6;\n$text-gray: #bdbdbd;\n$border-dark: #404040;\n$toggle-text: #616161;\n$black: black;\n$white: white;\n$border-color: #aaaaaa;\n$text-dark-gray: #616161;\n\n//CommonSelect\n.planpage {\n    padding: 30px 50px;\n}\n\n.checkout-custom-select {\n    display: flex;\n    flex-direction: column;\n\n    span {\n        font-weight: 700;\n    }\n\n    select {\n        border: 1px solid #d4d4d8;\n        border-radius: 10px;\n        padding: 10px;\n        width: 100%;\n        margin-top: 4px;\n        cursor: pointer;\n        appearance: none; // Removes default dropdown styling in some browsers\n\n        &:focus {\n            outline: none;\n            border-color: #3b82f6;\n            box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);\n        }\n    }\n}\n\n.checkoutCustomInput {\n    display: flex;\n    flex-direction: column;\n\n    span {\n        font-weight: 700;\n    }\n\n    input {\n        border: 1px solid #d4d4d8;\n        border-radius: 10px;\n        padding: 10px;\n        width: 100%;\n        margin-top: 4px;\n        font-size: 16px;\n\n        &:focus {\n            outline: none;\n            border-color: #3b82f6;\n            box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);\n        }\n    }\n}\n\n//SubscriptionPage\n.subscription-container {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 20px;\n    margin-top: 20px;\n\n    @media (min-width: 640px) {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .subscription-box {\n        width: 100%;\n        height: 100vh;\n        border: 1px solid #d4d4d8;\n        border-radius: 10px;\n        padding: 20px;\n        overflow: auto;\n        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n\n        .zoho-checkout-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n\n            h3 {\n                font-weight: 700;\n                font-size: 24px;\n            }\n        }\n\n        .plan-section,\n        .billing-section,\n        .details-section {\n            margin-top: 20px;\n\n            .zoho-checkout-address-section {\n                width: 100%;\n                display: grid;\n                grid-template-columns: repeat(2, 1fr);\n                margin-top: 0.5rem;\n                gap: 1.25rem;\n            }\n\n            h4 {\n                font-weight: 700;\n                font-size: 16px;\n                margin-bottom: 10px;\n            }\n\n            .plan-info {\n                .left-side {\n                    h4 {\n                        font-size: 16px;\n\n                        span {\n                            color: #3b82f6;\n                        }\n                    }\n\n                    .licence-type {\n                        font-size: 16px;\n                        color: black;\n                        margin-top: 10px;\n                    }\n                }\n\n                border: 1px solid #d4d4d8;\n                border-radius: 10px;\n                padding: 20px;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                .license-input {\n                    border: 1px solid #d4d4d8;\n                    border-radius: 10px;\n                    padding: 10px;\n                    padding-top: 0px;\n                    padding-bottom: 0px;\n                    display: flex;\n                    align-items: center;\n                    gap: 10px;\n                    margin-top: 10px;\n                    justify-content: space-between;\n\n                    button {\n                        font-size: 24px;\n                        background: none;\n                        border: none;\n                        cursor: pointer;\n                    }\n                }\n            }\n\n            .billing-options {\n                display: grid;\n                grid-template-columns: 1fr 1fr;\n                gap: 20px;\n\n                button {\n                    width: 100%;\n                    padding: 20px;\n                    font-size: 16px;\n                    font-weight: 700;\n                    text-align: left;\n                    border-radius: 10px;\n                    cursor: pointer;\n                }\n\n                .selected {\n                    border: 4px solid #3b82f6;\n                }\n\n                .not-selected {\n                    border: 1px solid #d4d4d8;\n                }\n            }\n\n            .input-field {\n                width: 100%;\n                border: 1px solid #d4d4d8 !important;\n                border-radius: 10px;\n                padding: 10px;\n            }\n        }\n\n        .plan-section {\n            .plan-page-title {\n                font-size: 16px;\n                font-weight: 700;\n                margin-bottom: 10px;\n            }\n\n            h4 {\n                font-weight: 400;\n                font-size: 14px;\n                margin-bottom: 0px;\n            }\n        }\n\n        .coupon-section {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-top: 10px;\n            gap: 20px;\n\n            .custom-discount-apply-button {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                gap: 20px;\n            }\n\n            button {\n                border-radius: 10px;\n                padding: 10px 20px;\n                font-size: 14px;\n                font-weight: 600;\n                cursor: pointer;\n\n                &.custom-discount-clear-btn {\n                    background-color: red;\n                    color: white;\n                }\n\n                &.custom-discount-apply-btn {\n                    background-color: #3b82f6;\n                    color: white;\n                }\n            }\n        }\n\n        .pricing-summary {\n            margin-top: 20px;\n            border-top: 1px solid #d4d4d8;\n            padding-top: 20px;\n\n            .summary-item {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-top: 10px;\n\n                h4 {\n                    font-weight: 700;\n                    font-size: 20px;\n\n                    &.discount {\n                        color: #6b7280;\n                    }\n                }\n            }\n        }\n\n        .purchase-button {\n            width: 100%;\n            margin-top: 20px;\n            background-color: #3b82f6;\n            color: white;\n            font-weight: 600;\n            font-size: 16px;\n            border-radius: 10px;\n            padding: 15px;\n            text-align: center;\n            cursor: pointer;\n        }\n    }\n\n    .subscription-image {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n// Container\n.plan-container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .plan-type-group {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 20px;\n\n        .plan-type-btn {\n            font-size: 16px;\n            font-weight: 600;\n            padding-bottom: 10px;\n            border-bottom: 2px solid transparent;\n            color: $text-gray;\n            transition: all 0.3s ease-in-out;\n            background-color: transparent;\n            cursor: pointer;\n\n            &.active {\n                background-color: transparent;\n                color: $black;\n                border-color: $primary-color;\n            }\n        }\n    }\n\n    // Plan Tenure Toggle\n    .plan-tenure-toggle {\n        border: 1px solid $border-dark;\n        display: flex;\n        align-items: center;\n        height: 40px;\n        width: max-content;\n        padding: 6px;\n        border-radius: 10px;\n        gap: 10px;\n\n        .tenure-btn {\n            height: 100%;\n            border-radius: 6px;\n            padding: 0 10px;\n            font-size: 14px;\n            font-weight: 500;\n            transition: all 0.3s ease-in-out;\n            background: transparent;\n            color: $toggle-text;\n            cursor: pointer;\n\n            &.active {\n                background: $black;\n                color: $white;\n            }\n        }\n    }\n}\n\n.plan-section-tabs-container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: -1px;\n\n    .plan-section-tabs-group-list {\n        width: 100%;\n        display: flex;\n        align-items: center;\n\n        .plan-type-btn {\n            font-size: 16px;\n            font-weight: 600;\n            // padding-bottom: 10px;\n            border-bottom: 0px;\n            // color: #616161;\n            transition: all 0.3s ease-in-out;\n            cursor: pointer;\n            padding: 7.5px 20px;\n            border-top-left-radius: 10px;\n            border-top-right-radius: 10px;\n            // border: 1px solid transparent;\n            // border-bottom: 0;\n            background-color: transparent;\n\n            &.active {\n                color: #3B82F6;\n                border-color: #D4D4D8;\n                background-color: #fff;\n            }\n        }\n    }\n}\n\n// Plan Grid Container\n.plan-grid {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0;\n    background-color: #fff;\n    border: 1px solid #D4D4D8;\n    border-radius: 0px 10px 10px 10px;\n\n    @media (min-width: 640px) {\n        grid-template-columns: repeat(4, 1fr);\n    }\n\n    .plan-card {\n        border-bottom: 1px solid $border-color;\n        padding: 20px;\n        padding-left: 0;\n\n        &:nth-child(4n+1) {\n            padding-left: 20px;\n        }\n\n        &:nth-child(4n) {\n            padding-left: 0;\n        }\n\n        cursor: pointer;\n\n        .plan-title {\n            font-weight: 600;\n            font-size: 16px;\n            margin-bottom: 15px;\n            color: $text-dark-gray;\n        }\n\n        .plan-image {\n            width: 100%;\n            object-fit: cover;\n            transition: transform 0.2s ease-in-out;\n\n            &:hover {\n                transform: scale(1.02);\n            }\n        }\n    }\n}\n\n.cancel-subscription-warn-container {\n    padding: 20px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 14px;\n\n    .cancel-subscription-warn-header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        h2 {\n            font-size: 20px;\n            font-weight: 700;\n        }\n\n        button {\n            background: none;\n            border: none;\n            cursor: pointer;\n        }\n    }\n\n    .cancel-subscription-warn-description {\n        font-size: 15px;\n        font-weight: 400;\n        text-align: left;\n        width: 100%;\n        color: #6b7280;\n    }\n\n    .cancel-subscription-warn-actions {\n        width: 100%;\n        display: flex;\n        justify-content: flex-end;\n\n        .primaryButton {\n            background-color: #3b82f6;\n            color: white;\n            border-radius: 6px;\n            width: auto;\n            padding: 10px 20px;\n            border: 0;\n            cursor: pointer;\n\n            &:disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n            }\n        }\n    }\n}\n\n.zoho-custom-checkbox {\n    all: unset; // Resets all styles to the browser's default\n    -webkit-appearance: auto; // Add webkit prefix for Safari iOS support\n    appearance: auto; // Ensures default browser styling\n    display: inline-block;\n    width: auto;\n    height: auto;\n}\n\n.checkbox-label-zoho-cancel-current {\n    padding-left: 10px;\n}\n\n// .zoho-checkout-org-table-container {\n//   width: 100%;\n//   overflow-x: auto;\n//   .custom-table {\n//     width: 100%;\n//     border-collapse: collapse;\n//     border-radius: 10px;\n//     overflow: hidden;\n//     border: 1px solid #ddd;\n//     th,\n//     td {\n//       padding: 12px;\n//       text-align: left;\n//       border: 1px solid #ddd;\n//     }\n//     th {\n//       background-color: #f4f4f4;\n//     }\n//     tr {\n//       background-color: #fff;\n//       &:nth-child(even) {\n//         background-color: #f9f9f9;\n//       }\n//     }\n//   }\n// }\n.zoho-coupon-container {\n    padding-top: 20px;\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n    flex-direction: column;\n    padding: 20px;\n    width: 100%;\n\n    .zoho-header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        h2 {\n            font-size: 20px;\n            font-weight: 700;\n        }\n    }\n\n    .sub-header {\n        font-size: 16px;\n        color: #6b7280;\n        font-weight: 500;\n        text-align: center;\n        width: 100%;\n    }\n\n    .coupon-card {\n        width: 100%;\n        border: 1px solid #d1d5db;\n        border-radius: 6px;\n        height: auto;\n\n        .coupon-content {\n            display: flex;\n            align-items: flex-start;\n            gap: 20px;\n            padding: 20px;\n            width: 100%;\n\n            .coupon-details {\n                display: flex;\n                flex-direction: column;\n                gap: 10px;\n                width: 100%;\n\n                h4 {\n                    font-size: 20px;\n                    font-weight: 700;\n                }\n\n                h5 {\n                    font-size: 16px;\n                    font-weight: 700;\n                    color: #6b7280;\n                }\n\n                .coupon-actions {\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    width: 100%;\n\n                    .coupon-code {\n                        border-radius: 6px;\n                        background-color: #d1d5db;\n                        padding: 6px 10px;\n                        font-weight: 600;\n                        width: max-content;\n                    }\n\n                    .apply-button {\n                        font-size: 16px;\n                        color: #3b82f6;\n                        font-weight: 600;\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
